import React from "react";
import UserService from "../utilities/userService";
import { HeaderSafeZone } from "./headerSafeZone";

const safeZoneId = "header-top";

export interface HeaderSafeZoneWrapperProps {
  safeZoneCallback: (element: HTMLElement) => void;
  setHeaderSafeZone: (element: HTMLElement) => void;
  headerSafeZoneHeight: number;
  headerSafeZoneWidth: number;
}

class HeaderSafeZoneWrapper extends React.Component<HeaderSafeZoneWrapperProps> {
  private observer: MutationObserver | null = null;

  constructor(props: HeaderSafeZoneWrapperProps) {
    super(props);

    this.getSafeZoneDivHtml = this.getSafeZoneDivHtml.bind(this);
  }

  componentDidMount() {
    if (typeof document !== "undefined") {
      // Select the node that will be observed for mutations
      const targetNode = document.getElementById(safeZoneId);
      if (targetNode !== null) {
        // Options for the observer (which mutations to observe)
        const config = { childList: true };

        if (typeof MutationObserver !== "undefined") {
          // Create an observer instance linked to the callback function
          this.observer = new MutationObserver(() => {
            this.getSafeZoneDivHtml();
          });

          // Start observing the target node for configured mutations
          this.observer.observe(targetNode, config);
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  getSafeZoneDivHtml() {
    if (typeof document !== "undefined") {
      const element = document.getElementById(safeZoneId) as HTMLElement;
      const imgTags = element.getElementsByTagName("img");

      for (let i = 0; i < imgTags.length; i++) {
        imgTags[i].onload = () => {
          this.props.setHeaderSafeZone(element);
        };
      }

      if (element && element.innerHTML && UserService.displayUserInfo()) {
        this.props.safeZoneCallback(element);
      }
    }
  }

  render() {
    return (
      <div className="row d-lg-block header-safe-zone-wrapper">
        <div className="col-12">
          <HeaderSafeZone setHeaderSafeZone={this.props.setHeaderSafeZone} />
        </div>
      </div>
    );
  }
}

export default HeaderSafeZoneWrapper;
